/*=============================
=       Lazy Load Images      =
=============================*/

document.addEventListener('DOMContentLoaded', function() {
	var heroImages = [].slice.call(document.querySelectorAll('#hero .bg-container')),
		lazyImages = [].slice.call(document.querySelectorAll('main img:not(.not-lazy):not(.first), .section_video video, .section_video iframe, .video-full, .bg-container:not(.first)')),
		active = false,
		heroLazyLoad = function() {
			heroImages.forEach(function(img) {
				imgLazyLoad(img, 300);

				heroImages = heroImages.filter(function(image) {
					return image !== img;
				});

				if(heroImages.length === 0) {
					document.removeEventListener('scroll', heroLazyLoad);
					window.removeEventListener('resize', heroLazyLoad);
					window.removeEventListener('orientationchange', heroLazyLoad);
				}
			});
		};

	// Hero Images
	setTimeout(heroLazyLoad, 1);

	// Regular Images
	var lazyLoad = function() {
		if(active === false) {
			active = true;

			setTimeout(function() {
				lazyImages.forEach(function(img) {
					if((img.getBoundingClientRect().top <= (window.innerHeight + 300) && img.getBoundingClientRect().bottom >= 0) && getComputedStyle(img).display !== 'none') {
						imgLazyLoad(img, (img.classList.contains('bg-container') ? 300 : 0));

						lazyImages = lazyImages.filter(function(image) {
							return image !== img;
						});

						if(lazyImages.length === 0) {
							document.removeEventListener('scroll', lazyLoad);
							window.removeEventListener('resize', lazyLoad);
							window.removeEventListener('orientationchange', lazyLoad);
						}
					}
				});

				active = false;
			}, 200);
		}
	};

	document.addEventListener('scroll', lazyLoad);
	window.addEventListener('resize', heroLazyLoad);
	window.addEventListener('resize', lazyLoad);
	window.addEventListener('orientationchange', heroLazyLoad);
	window.addEventListener('orientationchange', lazyLoad);
});

function imgLazyLoad(img, delay) {
	var url = img.getAttribute('data-src'+(checkWidth(768) && img.hasAttribute('data-src-mobile') ? '-mobile' : ''));

	if(img.tagName == 'IMG' || img.tagName == 'VIDEO' || img.tagName == 'IFRAME')
		img.src = url;
	else
		img.style.backgroundImage = 'url('+url+')';

	setTimeout(function() {
		img.classList.add('loaded');
	}, delay);
}

/*=============================
=         Sticky Header       =
=============================*/

var stickyHeader = new Waypoint({
	element: logo,
	handler: function(direction) {
		var down = direction == 'down';

		if(down)
			body.classList.add('sticky');
		else
			body.classList.remove('sticky');
	},
	offset: header.offsetHeight
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});

/*=============================
=             Menu            =
=============================*/

var menu = document.getElementById('menu'),
	mobileMenuButton = document.getElementById('mobile-menu-button'),
    locationPageActive = document.getElementById('locations-dropdown').querySelector('ul.locations').querySelector('.active');

body.addEventListener('click', function(e) {
	var open = openMenu(e.target);

	if(open) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
});

[].slice.call(header.querySelectorAll('button:not(#search-button):not(.language-button)')).forEach(function(navLink) {
	navLink.addEventListener('click', toggleMenu);

});

if(locationPageActive){

    console.log(locationPageActive.textContent)
    document.getElementById('choose-location').innerHTML = locationPageActive.textContent + '<span></span>';
}

function toggleMenu() {
	closeMenu(openMenu(this));

	var parent = this.parentNode.parentNode,
		openSibling = parent.querySelector('.open');

	if(parent.classList.contains('submenu') && openSibling && openSibling != this)
		closeMenu(openSibling);

	Velocity(this.nextElementSibling, (this.classList.contains('open') ? 'slideUp' : 'slideDown'), {duration: this == mobileMenuButton ? 300 : 150});

	this.classList.toggle('open');

	this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	toggleMenuBodyClass(header.querySelector('.open'), this == mobileMenuButton);
}

function closeMenu(el) {
	if(el) {
		var submenu = el.nextElementSibling;

		Velocity(submenu, 'slideUp', {duration: el == mobileMenuButton ? 300 : 150});

		el.classList.remove('open');

		closeMenu(submenu.querySelector('.open'));
	}
}

function openMenu(el) {
	if(mobileMenuButton && mobileMenuButton.classList.contains('open') && mobileMenuButton != el && !mobileMenuButton.contains(el) && !document.getElementById('menu-container').contains(el))
		return mobileMenuButton;

	var openButton = header.querySelector('button:not(#mobile-menu-button).open');

	return openButton && !openButton.parentNode.contains(el) ? openButton : false;
}

function toggleMenuBodyClass(open, ismobileMenuButton) {
	if(open) {
		body.classList.add('menu-open');

		if(checkWidth(1200) && ismobileMenuButton)
			body.classList.add('mobile-menu-open');
	}
	else {
		body.classList.remove('menu-open');

		if(checkWidth(1200))
			body.classList.remove('mobile-menu-open');
	}

	setFocus((open ? true : false), header);
}

function setFocus(open, container) {
	[].slice.call(document.querySelectorAll('#header, #hero, #main, #trustlogos, #footer')).forEach(function(parent) {
		if(parent != container) {
			parent.setAttribute('aria-hidden', open);

			[].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
				if(open)
					link.setAttribute('tabindex', '-1');
				else
					link.removeAttribute('tabindex');
			});
		}
	});
}

/*=============================
=        Skip to Content      =
=============================*/

var skipLink = document.getElementById('skip-link');

skipLink.addEventListener('click', function(e) {
	e.preventDefault();

	var firstLink = document.querySelector('#hero a, main a');

	if(firstLink) {
		scrollToElement(firstLink);
		firstLink.focus();
	}
});

function skipLinkToggleDisplay(hide) {
	skipLink.style.display = hide ? 'none' : '';
}

/*=============================
=        Scroll To Link       =
=============================*/

var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link'));

scrollLinks.forEach(function(scrollLink) {
	scrollLink.addEventListener('click', function(e) {
		if(this.tagName == 'A')
			e.preventDefault();

		scrollToElement(document.querySelector(this.getAttribute('href')));
	});
});

function scrollToElement(scrollTo) {
	Velocity(scrollTo, 'scroll', {duration: 800, offset: -(headerHeight - topbarHeight)});
}

var sectionId = window.location.hash,
	section = sectionId ? document.querySelector(sectionId) : false;

if(section) {
	setTimeout(function() {
		scrollToElement(section);
	}, 300);

	if(section.parentNode.classList.contains('accordion')) {
		setTimeout(function() {
			Velocity(section.querySelector('.answer'), 'slideDown', {duration: 250});

			var button = section.querySelector('button');

			button.classList.add('open');

			button.setAttribute('aria-expanded', 'true');
		}, 1200);
	}
}

/*=============================
=         Element Link        =
=============================*/

var links = [].slice.call(document.querySelectorAll('.link'));

links.forEach(function(link) {
	link.addEventListener('click', function(e) {
		if(e.target.tagName !== 'A' && this.hasAttribute('data-href')) {
			var href = this.dataset.href;

			if(href.indexOf(location.host) == -1)
				window.open(href);
			else
				window.location.href = href;
		}
	});
});

/*=============================
=          Accordion          =
=============================*/

var accordions = [].slice.call(document.querySelectorAll('.accordion button, .interactive-body-image .dot, #footer-menu button')),
	bodyModal = document.getElementById('interactive-body-modal');

accordions.forEach(function(accordion) {
	accordion.addEventListener('click', function() {
		var isDot = this.classList.contains('dot'),
			dot = isDot ? this : document.querySelector('.interactive-body-image button[data-accordion="'+this.parentNode.id+'"]'),
			button = isDot ? document.querySelector('#'+this.dataset.accordion+' > button') : this,
			answer = isDot ? document.getElementById(this.dataset.accordion).querySelector('.answer') : this.nextSibling,
			animation = window.getComputedStyle(answer).display == 'block' ? 'slideUp' : 'slideDown',
			interactiveBody = document.querySelector('section.section_body .accordion');

		if(checkWidth(768) && interactiveBody && interactiveBody.contains(this)) {
			bodyModal.querySelector('.text-container').innerHTML = '<h2>'+this.querySelector('h4').innerHTML+'</h2>'+answer.innerHTML;

			Velocity(bodyModal, {opacity: [1,0]}, {duration: 300, display: 'block'});
		}
		else {
			if(dot) {
				currentDot = dot.parentNode.parentNode.querySelector('.dot.current');

				if(currentDot && currentDot !== dot)
					currentDot.classList.remove('current');

				dot.classList.toggle('current');
			}

			closeAccordion(button);

			Velocity(answer, animation, {duration: 250});

			button.classList.toggle('open');

			button.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

			// setTimeout(function() {
			// 	scrollToElement(this.parentNode);
			// }, 250);
		}
	});
});

function closeAccordion(el) {
	var openAccordion = el.parentElement.parentElement.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		Velocity(openAccordion.nextSibling, 'slideUp', {duration: 250});

		openAccordion.classList.toggle('open');
	}
}

/*=============================
=       Google Translate      =
=============================*/

var languageSwitchers = [].slice.call(document.querySelectorAll('.language-switcher button'));

languageSwitchers.forEach(function (switcher) {
    switcher.addEventListener('click', function (e) {
        var parent = this.parentNode,
            list = parent.querySelector('ul');

        closeDropDown(parent, e);

        this.classList.toggle('open');

        Velocity(list, (window.getComputedStyle(list).display == 'block' ? 'slideUp' : 'slideDown'), {duration: 150});
    });
});

body.addEventListener('click', function (e) {
    closeDropDown(this, e);
});

function closeDropDown(el, e) {
    var open = document.querySelector('.language-switcher.open');

    if (open) {
        if (open !== el && !open.contains(e.target)) {
            open.classList.remove('open');
            Velocity(open.querySelector('ul'), 'slideUp', {duration: 150});
        }
    }
}

var languages = [].slice.call(document.querySelectorAll('.language-switcher a'));

languages.forEach(function (language) {
    language.addEventListener('click', function (e) {
        e.preventDefault();

        var lang = this.dataset.lang;

        if (Cookie.get('language') !== lang) {
            Cookie.set('language', lang);
            Cookie.set('language-text', this.innerHTML);
            googTransHandle(false, lang);

            var splitDomain = location.host.split('.');



            if (splitDomain.length > 2){

                googTransHandle(location.host.replace(splitDomain[0], ''), lang);
            }

            window.location.reload();
        }
    });
});

function googTransHandle(domain, lang) {
	if(!domain) {

		if(typeof Cookie.get('googtrans') !== 'undefined'){

            Cookie.remove('googtrans');
        }

		if(lang!=='en')
			Cookie.set('googtrans', '/en/'+lang);
	} else {
		if(typeof Cookie.get('googtrans', {domain: domain})!=='undefined')
			Cookie.remove('googtrans', {domain: domain});
		if(lang!=='en')
			Cookie.set('googtrans', '/en/'+lang, {domain: domain});
	}
}

if (typeof Cookie.get('googtrans') !== 'undefined') {
    // var script = document.createElement('script');
    // script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    // script.type = 'text/javascript';
    // script.setAttribute('async', 'true');
    // document.body.appendChild(script);

    languageSwitchers.forEach(function (switcher) {
        switcher.innerHTML = Cookie.get('language');
    });
}

// function googleTranslateElementInit() {
//     var language = new google.translate.TranslateElement(
//         {pageLanguage: 'en'}, false
//     );
// }

/*=============================
=             Modal           =
=============================*/

var modals = [].slice.call(document.querySelectorAll('div[role="dialog"]'));

modals.forEach(function(modal) {
	modal.addEventListener('click', function(e) {
		if(e.target == modal.querySelector('button') || !modal.querySelector('.content').contains(e.target))
			closeModal();
	});
});

function closeModal() {
	modals.forEach(function(modal) {
		if(window.getComputedStyle(modal).display == 'block')
			Velocity(modal, {opacity: [0,1]}, {duration: 300, display: 'none'});

		// if(modal == videoModal) {
		// 	setTimeout(function() {
		// 		videoIframe.src = 'about:blank';
		// 	}, 300);
		// }
	});
}

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		closeModal();
});


/*=============================
=            Search           =
=============================*/

var searchForm = document.getElementById('site-search');

if(searchForm) {
	searchInput = searchForm.querySelector('input');

	document.getElementById('search-button').addEventListener('click', function() {
		if(!checkWidth(1200)) {
			if(body.classList.contains('search-open') && searchInput.value === '') {
				body.classList.remove('search-open');
				searchInput.setAttribute('aria-hidden', 'true');
				searchInput.setAttribute('tabindex', '-1');
			}
			else {
				body.classList.add('search-open');
				searchInput.setAttribute('aria-hidden', 'false');
				searchInput.removeAttribute('tabindex');
				searchInput.focus();
			}
		}
	});

    document.addEventListener('click', function(e){

        if(!searchForm.contains(e.target)){
            if(body.classList.contains('search-open') && searchInput.value === '') {
                body.classList.remove('search-open');
                searchInput.setAttribute('aria-hidden', 'true');
                searchInput.setAttribute('tabindex', '-1');
            }
        }

    })

	searchForm.addEventListener('submit', function(e) {
		e.preventDefault();

		if(searchInput.value !== '')
			window.location.href = '/search?q='+searchInput.value+'#search-results';
	});
}

/*=============================
=             Video           =
=============================*/

[].slice.call(document.querySelectorAll('.video-container button')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var parent = this.parentNode.parentNode,
			thumbnail = parent.querySelector('.thumbnail'),
			video = parent.querySelector('figure.video > *:first-child');

		if(thumbnail)
			Velocity(thumbnail, {opacity: [0,1]}, {duration: 150, display: 'none'});

		playVideo(video);
	});
});

function playVideo(video) {
	video.src = video.dataset.src;

	if(video.tagName === 'VIDEO')
		video.autoplay = true;
}

function resetVideo(video) {
	var src = video.src;

	video.src = src.replace('?autoplay=1&rel=0', '').replace('&autoplay=1&rel=0', '');
}

// Play/Pause Background Video
[].slice.call(document.querySelectorAll('section.section_video .video-controls')).forEach(function(videoButton) {
	videoButton.addEventListener('click', function() {
		var videoPaused = this.classList.contains('play'),
			video = this.parentNode.querySelector('.video-bg');

		if(videoPaused)
			video.play();
		else
			video.pause();

		this.classList.toggle('play');

		this.setAttribute('aria-label', (videoPaused ? 'Pause' : 'Play') + ' Video');
	});
});

// Fullscreen Video
var videoFull;

[].slice.call(document.querySelectorAll('button[class*="video-full"]')).forEach(function(videoModalButton) {
	videoModalButton.addEventListener('click', function() {
		videoFull = this.closest('section').querySelector('.video-full');

		if(videoFull.tagName == 'VIDEO')
			videoFull.play();
		else
			videoFull.src += '&autoplay=1&rel=0';

		videoFull.requestFullscreen();
	});
});

document.addEventListener('fullscreenchange', function() {
	if(videoFull && !document.fullscreenElement) {
		if(videoFull.tagName == 'VIDEO') {
			videoFull.pause();
			videoFull.currentTime = 0;
		}
		else
			resetVideo(videoFull);
	}
});

/*=============================
=          Google Map         =
=============================*/

var mapContainer = document.querySelector('.map-container');

if(mapContainer) {
	scriptWaypoint(mapContainer, 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCNmif7CZ1_pz7EHdZhK9MaSRezdGXwmtU&callback=initMap', '150%');

	window.initMap = initMap;
}

function initMap() {
	var openwindow,
		pin = '/assets/images/icons/map-pin.svg',
		currentPin = '/assets/images/icons/map-pin-current.svg';

	axios.get('/map-section/'+(body.classList.contains('location') ? body.id : 'all')).then(function(r) {
		var locations = r.data.locations,
			center = JSON.parse('[40.737511,-74.0498697]'),
			mapOptions = {
				zoom: checkWidth(768) && body.id == 'hoboken' ? 12 : 11.5,
				streetViewControl: false, // hide the yellow Street View pegman
				scaleControl: true, // allow users to zoom the Google Map
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				disableDefaultUI: true,
				center: new google.maps.LatLng(center[0], center[1]),
				styles: mapStyles
			},
			map = new google.maps.Map(mapContainer, mapOptions);

		locations.forEach(function(location) {
			var isLocationPage = location.openWindow,
				coordinates = JSON.parse('['+location.coordinates+']'),
				latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
				marker = new google.maps.Marker({
					map: map,
					position: latLng,
					draggable: false,
					animation: google.maps.Animation.DROP,
					icon: pin
				}),
				infowindow = new google.maps.InfoWindow({
					position: latLng,
					content: location.html
				});

			if(isLocationPage) {
				infowindow.open(map, marker);
				openWindow = infowindow;

				marker.setIcon(currentPin);
      			currentMarker = marker;
			}

			infowindow.addListener('closeclick', function() {
	        	openWindow = false;
	        	currentMarker.setIcon(pin);
	        });

			marker.addListener('click', function() {
				if(currentMarker)
        			currentMarker.setIcon(pin);

				if(openWindow)
        			openWindow.close();

        		if(currentMarker != marker) {
	      			marker.setIcon(currentPin);
	      			currentMarker = marker;

	      			infowindow.open(map, marker);
      				openWindow = infowindow;

      				if(!body.classList.contains('location'))
      					setCenter(map, latLng, 0, -100);
	      		}
	      		else {
	      			openWindow = false;
	      			currentMarker = false;
	      		}
	        });
		});
	});

}

function setCenter(map, latlng, offsetx, offsety) {
    var point1 = map.getProjection().fromLatLngToPoint(
        (latlng instanceof google.maps.LatLng) ? latlng : map.getCenter()
    );
    var point2 = new google.maps.Point(
        ( (typeof(offsetx) == 'number' ? offsetx : 0) / Math.pow(2, map.getZoom()) ) || 0,
        ( (typeof(offsety) == 'number' ? offsety : 0) / Math.pow(2, map.getZoom()) ) || 0
    );
    map.panTo(map.getProjection().fromPointToLatLng(new google.maps.Point(
        point1.x - point2.x,
        point1.y + point2.y
    )));
}

/*=============================
=            Slider           =
=============================*/

var slider,
	sliderButtons = [].slice.call(document.querySelectorAll('.reviews-slider > button'));

sliderButtons.forEach(function(button) {
	button.addEventListener('click', function() {
		slider = button.parentNode;

		slideCard(this.className);
	});
});

document.addEventListener('keydown', function(e) {
	if(sliderButtons && slider && isInViewport(slider)) {
		var direction = e.key == 'ArrowRight' ? 'next' : 'prev';

		slider.querySelector('button.'+direction).focus();
		slideCard(direction);
	}
});

function slideCard(direction) {
	var slides = slider.querySelectorAll('.review-card'),
		slidesTotal = slides.length,
		sliderPos = Math.ceil(slider.getBoundingClientRect().left),
		lastSlide = slides[slidesTotal-1],
		defaultDisplay = checkWidth(768) ? 1 : 2,
		isNext = direction == 'next',
		gap = slides[0].offsetWidth + parseInt(window.getComputedStyle(slides[0]).marginRight);

	for(var i=0; i<slidesTotal; i++) {
		if((sliderPos - Math.ceil(slides[i].getBoundingClientRect().left)) == 0) {
			var numDisplay = defaultDisplay;

			if(!checkWidth(768) && isNext && ((slidesTotal - (defaultDisplay+i)) < defaultDisplay))
				numDisplay = slidesTotal - (defaultDisplay+i);

			var nextDisplay = i+numDisplay,
				currentCard = isNext ? (nextDisplay >= slidesTotal ? -1 : nextDisplay) : (i == 1 ? 0 : (i-numDisplay));

			if(currentCard >= 0) {
				slider.querySelector('.reviews-container').style.transform = 'translateX('+(currentCard ? -(currentCard * gap) : 0)+'px)';

				slider.querySelector('button.prev').disabled = currentCard ? false : true;
				slider.querySelector('button.next').disabled = checkWidth(768) ? ((currentCard + defaultDisplay) >= slidesTotal) : (lastSlide.getBoundingClientRect().right + ((direction == 'next' ? -1 : 2) * lastSlide.offsetWidth)) < Math.ceil(slider.getBoundingClientRect().right);

				break;
			}
		}
	}
}

[].slice.call(document.querySelectorAll('.reviews-filters button')).forEach(function(button) {
	button.addEventListener('click', filterReviews);
});

[].slice.call(document.querySelectorAll('.reviews-filters-select select')).forEach(function(select) {
	select.addEventListener('change', filterReviews);
});

function filterReviews() {
	var isSelect = this.tagName == 'SELECT',
		parent = isSelect ? this.parentNode : this.parentNode.parentNode,
		currentFilter = parent.querySelector('.current'),
		sliderContainer = parent.parentNode.querySelector('.reviews-container');

	if(isSelect ? true : (this != currentFilter)) {
		if(!isSelect) {
			currentFilter.classList.remove('current');
			this.classList.add('current');
		}

		Velocity(sliderContainer.querySelectorAll('.review-card'), {opacity: [0,1]}, {duration: 750});

		axios.post('/reviews-load', {filter: isSelect ? this.value : this.dataset.filter})
		.then(function(r) {
			sliderContainer.style.transition = 'none';
			sliderContainer.style.transform = 'none';

			sliderContainer.parentNode.querySelector('button.prev').disabled = true;
			sliderContainer.parentNode.querySelector('button.next').disabled = false;

			sliderContainer.innerHTML = r.data.reviews;

			Velocity(sliderContainer.querySelectorAll('.review-card'), {opacity: [1,0]}, {delay: 100});

			setTimeout(function() {
				sliderContainer.style = null;
			}, 100);
		})
		.catch(function (e) {
			console.log(e);
		});
	}
}

/*=============================
=           Trustlogos        =
=============================*/

var trustlogosSection = document.querySelector('section.section_trustlogos');

if(checkWidth(480) && trustlogosSection)
	setSlider();

function setSlider() {
	var trustlogosContainer = trustlogosSection.querySelector('.trustlogos-container'),
		posX1 = 0,
        posX2 = 0,
        posInitial,
        posFinal,
        threshold = 50,
		trustlogos = trustlogosContainer.querySelectorAll('li'),
        slidesLength = trustlogos.length,
        firstSlide = trustlogos[0],
        lastSlide = trustlogos[slidesLength - 1],
        cloneFirst = firstSlide.cloneNode(true),
        cloneLast = lastSlide.cloneNode(true),
        index = 0,
        oldIndex = index,
        allowShift = true;

    // Clone first and last slide
    trustlogosContainer.appendChild(cloneFirst);
    trustlogosContainer.insertBefore(cloneLast, firstSlide);

	trustlogosContainer.style.left = getPosition();

	[].slice.call(trustlogosContainer.querySelectorAll('li:not(:nth-child(2))')).forEach(function(trustlogo) {
		trustlogo.style.opacity = '.2';
	});

	// Auto Scroll
	var trustlogosInterval,
		trustlogosWaypoint = new Waypoint({
		element: trustlogosSection,
		handler: function(direction) {
			var autoSlideLogos = function() {
				shiftSlide(1);
			};

			trustlogosInterval = setInterval(autoSlideLogos, 2500);

			this.destroy();
		},
			offset: '80%'
		});

    // Mouse events
    trustlogosContainer.onmousedown = dragStart;

    // Touch events
    trustlogosContainer.addEventListener('touchstart', dragStart);
    trustlogosContainer.addEventListener('touchend', dragEnd);
    trustlogosContainer.addEventListener('touchmove', dragAction);

	    // Bullet click events
    var sliderButtonsContainer = trustlogosSection.querySelector('.slider-buttons'),
		sliderButtons = sliderButtonsContainer.querySelectorAll('button');

	[].slice.call(sliderButtons).forEach(function(button, buttonIndex) {
		button.addEventListener('click', function() {
			clearInterval(trustlogosInterval);

			shiftSlide(buttonIndex - index);
		});
	});

    // Transition events
    trustlogosContainer.addEventListener('transitionend', checkIndex);

    function dragStart(e) {
        e = e || window.event;
        e.preventDefault();

        posInitial = trustlogosContainer.offsetLeft;

        if(e.type == 'touchstart') {
            posX1 = e.touches[0].clientX;
        } else {
            posX1 = e.clientX;
            document.onmouseup = dragEnd;
            document.onmousemove = dragAction;
        }
    }

    function dragAction(e) {
        e = e || window.event;

        if(e.type == 'touchmove') {
            posX2 = posX1 - e.touches[0].clientX;
            posX1 = e.touches[0].clientX;
        } else {
            posX2 = posX1 - e.clientX;
            posX1 = e.clientX;
        }

        trustlogosContainer.style.left = (trustlogosContainer.offsetLeft - posX2) + 'px';
    }

    function dragEnd(e) {
        posFinal = trustlogosContainer.offsetLeft;

        if(posFinal - posInitial < -threshold)
            shiftSlide(1, 'drag');
        else if(posFinal - posInitial > threshold)
            shiftSlide(-1, 'drag');
        else
            trustlogosContainer.style.left = (posInitial) + 'px';

        document.onmouseup = null;
        document.onmousemove = null;
    }

	function shiftSlide(dir, action) {
		trustlogosContainer.classList.add('shifting');

		if(allowShift) {
			if(!action)
				posInitial = trustlogosContainer.offsetLeft;

			oldIndex = index;
			index = index+dir;

			trustlogosContainer.style.left = getPosition();
		}

		allowShift = false;
	}

	function getPosition(iniPos) {
		var size = cloneLast.offsetWidth + 30;

		for(var i=0; i<index; i++)
			size+= trustlogos[i].offsetWidth + 30;

		size = size + Math.round(((index == -1 ? cloneLast : (index == slidesLength ? cloneFirst : trustlogos[index])).offsetWidth) / 2);

		return ((window.innerWidth / 2) - size) + 'px';
	}

	function checkIndex() {
		trustlogosContainer.classList.remove('shifting');

		if(index == -1) {
			index = slidesLength - 1;
			trustlogosContainer.style.left = getPosition();
		}

		if(index == slidesLength) {
			index = 0;
			trustlogosContainer.style.left = getPosition();
		}

		trustlogos[oldIndex].style.opacity = '.2';
		trustlogos[index].style.opacity = '1';

		sliderButtonsContainer.querySelector('.current').blur();
		sliderButtonsContainer.querySelector('.current').classList.remove('current');
		sliderButtons[index].classList.add('current');

		allowShift = true;
	}
}

if(body.classList.contains('mobile')) {

	var locationsMenu = document.getElementById('menu').querySelector('ul li:nth-of-type(1) .submenu li:nth-of-type(3)');

	var locationAppend = document.getElementById('menu').querySelector('ul li:nth-of-type(1)');

	locationAppend.insertAdjacentElement('afterend', locationsMenu);
	
} 
